<header class="title-container">
  <div class="icon-image">
    <i class="far fa-file-image"></i>
  </div>
  <div class="title-content">
    <h2 mat-dialog-title class="text-white">Selecione seu logotipo</h2>
    <div class="text-white font-11">Recomendado: width 125 x height 63</div>
  </div>
  <mat-dialog-actions class="pb-3 d-flex justify-content-end flex-1">
    <button type="button" mat-dialog-close class="btn-close">
      <i class="fas fa-times-circle"></i>
    </button>
  </mat-dialog-actions>
</header>
<mat-dialog-content class="mat-typography">
  <section class="row align-items-center">
    <div class="col-sm-3 d-flex align-items-end">
      <label for="file" class="text-center btn btn-outline-info">Selecionar</label>
      <input id="file" type="file" class="form-control d-none" (change)="fileChangeEvent($event.target.files)" />
    </div>
    <div class="col-sm-9">
      <div class="alert alert-info font-13" role="alert">
        <i class="mdi mdi-alert-circle-outline mr-2"></i>
        Tipo de arquivo suportado:
        <strong>PNG, JPG e JPEG</strong>
        | Tamanho máximo:
        <strong>15mb</strong>
      </div>
    </div>
  </section>
  <hr />
  <section class="row">
    <div class="col-sm-6">
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        [aspectRatio]="ratio"
        [cropperMinWidth]="90"
        [cropperMinHeight]="90"
        (imageCropped)="imageCropped($event)"
      ></image-cropper>
    </div>
    <div class="col-sm-6" *ngIf="croppedImageBase">
      <div class="text-center card-box p-4">
        <div class="pt-2 pb-2">
          <img [src]="croppedImageBase" class="mt-3" width="230px" height="auto" />
        </div>
      </div>
    </div>
  </section>
</mat-dialog-content>
<mat-dialog-actions class="pb-3 d-flex justify-content-center">
  <button type="button" class="btn btn-success btn-rounder btn-upload" (click)="close()">Salvar</button>
</mat-dialog-actions>
